import cx from 'classnames';
import React, { useState, useEffect } from 'react';
import styles from './UploadTextureModelSelect.module.scss';
import InfoDialogUI from './InfoDialog/InfoDialogUI';
import { ButtonV2 } from './ButtonV2/ButtonV2';
import { Image, Loader } from '../common';
import { LeftIcon } from '../assets/icons';
import { unityData } from '../constants/unityDataTextureModel';
import { UnityCanvasContainer } from './admin/unity';
import UnityContainer, { useUnityContext } from './container/unityContainer';
import { wait } from '../helpers/jsHelper';
import { updateDbProp, updateDbTexture } from '../helpers/idb';
import { getPropLightList, isExclusiveProp } from '../helpers/unityHelper';
import {
  selectLibraryPropInstantiated,
  selectRoomInitialized,
  selectUnityLoaded,
  setLibraryPropInstantiated,
  setRoomInitialized,
  setUnityLoaded,
} from '../redux/slicers/admin/curatorSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { UndoRedoContextProvider } from './admin/curator/UndoRedoContext';
import { UnityEvent } from '../helpers/unityPubSub';
import PubSub from 'pubsub-js';
import { TEXTURE_MAP } from '../config/constant/unityConstants';
import {
  getSceneJson,
  sendRenderForAutomation,
  sendRenderForAutomation360,
  updateTextureDataForTexturePage,
} from '../helpers/textureModelUploadHelper';
import {
  apiGet,
  apiGetAllProps,
  apiUpdateTextureV2GenerateStatus,
  getModelTemplateData,
} from '../helpers/api';
import { useSetupShortcuts } from '../hooks/useSetupShortcuts';
import { curatorShortcutsMap } from './admin/curator/CuratorShortcuts/curatorShortcuts.config';
import { ADMIN_MY_PRODUCTS_TEXTURE_EDIT_V2 } from '../config/constant/routePathConstant';
import { useNavigate } from 'react-router-dom';
import { successToast } from '../helpers/toastHelper';
import { ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2 } from '../constants/routePathConstants';
import { useUserContext } from '../contexts/UserContext';
import { fetchAllPages } from '../helpers/apiHelper';
import { Mixpanel, MxEvent } from '../common/Mixpanel';
import { OP_GET_TEXTURES_API } from '../config/constant/apiConstant';

export const UploadTextureModelSelect = (props) => {
  const { showApplyTextureModal, setShowApplyTextureModal } = props;
  return (
    <InfoDialogUI
      hideTitle
      dialogClassName={styles.dialog}
      bodyClassName={styles.modalBody}
      onClose={() => setShowApplyTextureModal(false)}
      show={showApplyTextureModal}
      centered={true}
      preventClose={true}
      backdropClassName={styles.backdrop}
      theme="v2">
      <UnityContainer>
        <UndoRedoContextProvider>
          <ModelSelectPopup props={props} />
        </UndoRedoContextProvider>
      </UnityContainer>
    </InfoDialogUI>
  );
};

const ModelSelectPopup = ({ props }) => {
  const { setShowApplyTextureModal, uploadedFiles: _uploadedFiles } = props;
  const [nextBtnLoader, setNextBtnLoader] = useState(false);
  const [showUnityWindow, setShowUnityWindow] = useState(false);
  const [savedPropData, setSavedPropData] = useState();
  const {
    handleVerticalRotationSpeed,
    handleHorizontalRotationSpeed,
    roomModule,
    materialModule,
    mainController,
  } = useUnityContext();
  const roomInitialized = useSelector(selectRoomInitialized);
  const [startInstantiateProp, setStartInstantiateProp] = useState(false);
  const [unityLoader, setUnityLoader] = useState(false);
  const [isApplyingTexture, setIsApplyingTexture] = useState(false);
  const libraryPropInstantiated = useSelector(selectLibraryPropInstantiated);
  const [selectedObjectInfoFromUnity, setSelectedObjectInfoFromUnity] = useState([]);
  const unityLoaded = useSelector(selectUnityLoaded);
  const dispatch = useDispatch();
  const [textureModels, setTextureModels] = useState([]);
  const [textureModelsCopy, setTextureModelsCopy] = useState([]);
  const [filtersList, setFiltersList] = useState([]);
  const [modelLoader, setModelLoader] = useState(false);
  const [materialData, setMaterialData] = useState({});
  const { isGuestUser } = useUserContext();
  const navigate = useNavigate();
  const [uploadedFiles, setUploadedFiles] = useState(_uploadedFiles);

  const updateThumbnails = async (files = []) => {
    // updating thumbnails as for some textures the thumbnail is not generated or take time to generate.
    // so, here i'm fetching the details of the texture again to get the thumbnail & low texture file of it.
    const noThumbnailTextures = files?.filter((a) => !a?.thumbnail || !a?.low_texture_file);
    if (noThumbnailTextures?.length > 0) {
      const ids = noThumbnailTextures.map((a) => a.id).join(',');
      const results = (
        await fetchAllPages(
          async (page) => await apiGet(`${OP_GET_TEXTURES_API}?id=${ids}&page=${page}`)
        )
      )?.results;

      setUploadedFiles((prev) => [
        ...prev.map((b) => {
          const isExits = results?.find((a) => a.id === b.id);
          if (isExits) {
            return {
              ...b,
              thumbnail: isExits?.thumbnail,
              low_texture_file: isExits?.low_texture_file,
            };
          }

          return b;
        }),
      ]);
    }
  };

  useEffect(() => {
    // here, checking that the _uploadedFiles is array or not i'm getting uploadedFiles as Array from some places and Object from some places.
    setUploadedFiles(
      Array.isArray(_uploadedFiles) ? _uploadedFiles?.filter(Boolean) : _uploadedFiles
    );
    if (Array.isArray(_uploadedFiles)) updateThumbnails(_uploadedFiles?.filter(Boolean));
  }, [_uploadedFiles]);

  const applyTextureOnUnityInformation = async () => {
    if (selectedObjectInfoFromUnity?.length) {
      setUnityLoader(true);
      setIsApplyingTexture(true);
      const result = await materialModule.selectTexture({
        texture: uploadedFiles?.[0],
        mapType: TEXTURE_MAP.DIFFUSE,
      });
      if (result === false) {
        throw new Error('unable to apply texture');
      }
    }
  };

  useEffect(() => applyTextureOnUnityInformation(), [selectedObjectInfoFromUnity]);

  useEffect(() => {
    const callbackN = async (_, receivedVallue) => {
      setSelectedObjectInfoFromUnity(receivedVallue);
    };

    const callbackModel = async (_, receivedVallue) => {
      setUnityLoader(false);
    };
    const callbackFunc = async (_, receivedVallue) => {
      setUnityLoader(false);
      setIsApplyingTexture(false);
      const value = JSON.parse(receivedVallue);
      setMaterialData((prev) => ({ ...prev, [value.objectName]: value }));
    };

    PubSub.subscribe(UnityEvent.GetSelectedObjectInfoOnSelection, callbackN);
    PubSub.subscribe(UnityEvent.ReceiveSelectedObjectInfo, callbackFunc);
    PubSub.subscribe(UnityEvent.OnLibraryPropInstantiated, callbackModel);

    return () => {
      PubSub.unsubscribe(callbackN);
      PubSub.unsubscribe(callbackFunc);
      PubSub.unsubscribe(callbackModel);
    };
  }, [unityLoaded]);

  useEffect(() => {
    if (libraryPropInstantiated) {
      setUnityLoader(false);
    }
  }, [libraryPropInstantiated]);

  useEffect(() => {
    if (roomInitialized && startInstantiateProp) {
      loadDataInUnityWindow();
      setIsApplyingTexture(false);
    }
  }, [roomInitialized, startInstantiateProp]);

  const resetValues = (str) => {
    setShowUnityWindow(false);
    setUnityLoader(false);
    setIsApplyingTexture(false);
    setSavedPropData(null);
    setStartInstantiateProp(false);
    setNextBtnLoader(false);
    dispatch(setRoomInitialized(false));
    dispatch(setLibraryPropInstantiated(false));
    if (str === 'hideModal') {
      dispatch(setUnityLoaded(false));
      setShowApplyTextureModal(false);
      setTextureModels();
      setTextureModelsCopy();
      setFiltersList([]);
    }
  };

  const getProductDetail = async () => {
    setModelLoader(true);
    const query = `is_automated_template=true&product_texture_template=true&is_texture_template=false`;
    const modelTemplateData = await fetchAllPages(
      async (page) => await getModelTemplateData({ query: `${query}&page=${page}` })
    );
    let allProductIds = modelTemplateData?.results?.map((data) => data.product).filter(Boolean);
    // remove duplicate array of number
    allProductIds = allProductIds?.filter(function (item, pos) {
      return allProductIds.indexOf(item) == pos;
    });
    const allPropData = await apiGetAllProps(allProductIds, 1, `is_guest_user=${isGuestUser()}`);
    const products =
      Array.isArray(uploadedFiles) && uploadedFiles?.length > 0
        ? allPropData.results?.filter((_item) =>
            uploadedFiles?.find((a) => a?.product?.id !== _item?.id)
          ) // if we have uploadedFiles as Array
        : allPropData.results?.filter((_item) => _item?.id !== uploadedFiles?.product?.id); // if we have uploadedFiles as Object
    if (products?.length) {
      setTextureModels([...products]);
      setTextureModelsCopy([...products]);
      let allFilters = [];
      products?.forEach((value) => {
        let filterOptions = value?.filteroptions?.map((data) => data.name)?.filter((val) => val);
        filterOptions = filterOptions?.filter(function (item, pos) {
          return filterOptions.indexOf(item) == pos;
        });
        filterOptions = filterOptions?.map((data) => {
          return {
            name: data,
            id: data.toLowerCase().replaceAll(' ', ''),
            selected: false,
          };
        });
        if (filterOptions?.length) {
          allFilters.push(...filterOptions);
        }
      });
      allFilters.unshift({
        name: 'All',
        id: 'all',
        selected: true,
      });
      setFiltersList(allFilters);
      setModelLoader(false);
    }
  };

  useEffect(() => {
    getProductDetail();
    return () => {
      resetValues('hideModal');
    };
  }, []);

  const checkForDisable = () => {
    if (showUnityWindow) {
      return unityLoader || !Object.keys(materialData)?.length;
    } else {
      const selectedItems = textureModels?.filter((data) => data?.selected);
      return !selectedItems?.length;
    }
  };

  const instantiateProp = async () => {
    const productDbData = await updateDbProp(savedPropData);
    const lightList = await getPropLightList(savedPropData);
    const prop = {
      type: 'PropLibrary',
      id: savedPropData.id,
      propName: savedPropData.name,
      locationUrl: savedPropData.is_windows_and_doors
        ? productDbData?.file_window_door || savedPropData.product_file_window_door
        : productDbData?.file || savedPropData.product_file,
      preDefinedMetadata: savedPropData.product_meta_info,
      roomLightDatas: lightList,
      isExclusiveProp: isExclusiveProp(savedPropData),
      isRoofProp: productDbData?.is_roof_prop,
      modelType: savedPropData?.prop_data_user_file ? 'UserImportModel' : '',
    };
    roomModule.addProp(prop);
  };

  const loadDataInUnityWindow = () => {
    handleVerticalRotationSpeed(120);
    handleHorizontalRotationSpeed(120);
    instantiateProp();
  };

  const proceedAfterModelSelect = async () => {
    if (props?.setProductData) {
      const selectedItems = textureModels?.find((data) => data?.selected);
      props?.setProductData(selectedItems, materialData);
      setShowApplyTextureModal(false);
      return;
    } else {
      if (showUnityWindow) {
        const selectedItems = textureModels?.filter((data) => data?.selected);
        Mixpanel.track(true, MxEvent.CLICK_EXPERIENCE_PRODUCT_COMPONENT_SELECTION, {
          prop_id: selectedItems?.[0]?.id,
          prop_name: selectedItems?.[0]?.name,
          component_selected: Object.keys(materialData)
            ?.map((key) => materialData?.[key]?.realObjName)
            ?.join(','),
        });

        if (uploadedFiles.length > 1) {
          setShowApplyTextureModal(false);
          const data = { appliedMaterials: materialData, ...(await getSceneJson()) };
          navigate(ADMIN_MY_PRODUCTS_TEXTURE_EDIT_V2, {
            state: { products: textureModels, textures: uploadedFiles, unityData: data, v2: true },
          });
        } else {
          setNextBtnLoader(true);
          const uploadedTextureId = uploadedFiles?.[0]?.id;
          const { isViewerJob, isImageJob } = uploadedFiles?.[0];
          await apiUpdateTextureV2GenerateStatus({
            id: uploadedTextureId,
            data: {
              generate_images_content_status: isImageJob === undefined || isImageJob ? 0 : 1,
              generate_360_content_status: isViewerJob === undefined || isViewerJob ? 0 : 1,
            },
          });
          await Promise.allSettled([
            (isImageJob === undefined || isImageJob) &&
              sendRenderForAutomation({
                uploadedProductId: savedPropData?.id,
                uploadedTextureId,
                data: savedPropData,
              }),
            (isViewerJob === undefined || isViewerJob) &&
              sendRenderForAutomation360({
                uploadedProductId: savedPropData?.id,
                uploadedTextureId,
                data: savedPropData,
              }),
            updateTextureDataForTexturePage(savedPropData?.id, uploadedTextureId),
          ]);
          resetValues('hideModal');
          successToast('Your visuals are being generated');
          await wait(1000);
          props?.onSuccess?.();
          navigate(ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2.replace(':id', uploadedTextureId));
        }
      } else {
        try {
          setNextBtnLoader(true);
          const selectedItems = textureModels?.filter((data) => data?.selected);

          Mixpanel.track(true, MxEvent.CLICK_EXPERIENCE_PRODUCT_SELECTED, {
            prop_id: selectedItems?.[0]?.id,
            prop_name: selectedItems?.[0]?.name,
          });

          const propIdList = [selectedItems?.[0]?.id];
          const allPropData = await apiGetAllProps(propIdList, 1, `is_guest_user=${isGuestUser()}`);
          let propDataToSave = allPropData?.results?.[0];
          propDataToSave = { ...propDataToSave, ...selectedItems?.[0] };
          setSavedPropData(propDataToSave);
          setUnityLoader(true);
          setShowUnityWindow(true);
          setNextBtnLoader(false);
          // await wait(500);
          setStartInstantiateProp(true);
        } catch (e) {
          setNextBtnLoader(false);
          setUnityLoader(false);
          console.log('errror', e);
        }
      }
    }
  };

  const getSelectedItem = () => {
    return textureModels?.filter((data) => data?.selected)?.length;
  };

  const selectAndFilter = (data) => {
    if (data.selected) return;
    let filterCopy = filtersList?.map((val) => {
      val['selected'] = val.id === data.id;
      return val;
    });
    setFiltersList([...filterCopy]);
    let localCopy = textureModelsCopy
      ?.filter((val) => {
        let filterOptions = val?.filteroptions?.map((data) => data.name)?.filter((val) => val);
        if (filterOptions?.includes(data.name) || data.name === 'All') {
          return val;
        }
      })
      .filter((val) => val);
    setTextureModels([...localCopy]);
  };
  return (
    <div className={styles.popupContainer}>
      {!showUnityWindow && (
        <div className={styles.headingText}>Choose a model to apply your texture to</div>
      )}
      {showUnityWindow && (
        <div className={styles.headingText}>
          <span onClick={() => resetValues()}>
            <LeftIcon />
          </span>{' '}
          Select where you’d like to apply your texture on the model
        </div>
      )}
      {!modelLoader && !showUnityWindow && textureModels?.length > 20 && (
        <div className={styles.mainFilters}>
          {filtersList?.map((data) => {
            return (
              <div
                className={`${styles.filterTag} ${data?.selected ? styles.selectedFilter : ''}`}
                onClick={() => selectAndFilter(data)}>
                {data?.name}
              </div>
            );
          })}
        </div>
      )}
      {!showUnityWindow && (
        <div
          className={textureModels?.length <= 20 ? 'pt-2' : ''}
          style={{ minHeight: '200px', width: '100%' }}>
          {modelLoader && <Loader loading={true} position="absolute" />}
          {!modelLoader && !!textureModels?.length && (
            <div className={`${styles.cardContainer}`}>
              {textureModels?.map((data, index) => {
                return (
                  <CardData
                    data={data}
                    index={index}
                    setTextureModels={setTextureModels}
                    setTextureModelsCopy={setTextureModelsCopy}
                    textureModelsCopy={textureModelsCopy}
                  />
                );
              })}
            </div>
          )}
        </div>
      )}
      {showUnityWindow && (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
          <Loader
            loading={unityLoader}
            position="absolute"
            className={cx(styles.loaderDisable, isApplyingTexture ? 'bg-transparent' : '')}
          />
          {unityData && (
            <UnityCanvasContainer data={unityData} className="h-100" isProject={true} />
          )}
          <InitHooks />
        </div>
      )}
      <div className={styles.footerContainer}>
        <div
          className="d-flex align-items-center justify-content-between w-100"
          style={{ padding: '1rem 40px' }}>
          <div>
            {showUnityWindow &&
              (selectedObjectInfoFromUnity?.length ? (
                <span className={styles.selectedItem}>
                  {selectedObjectInfoFromUnity?.length} selected
                </span>
              ) : (
                <span className={styles.guideline}>
                  Press “Shift” on your keyboard to multi-select the model parts.
                </span>
              ))}
            {!!showUnityWindow && <span style={{ color: '#fff' }}>selected</span>}
          </div>
          <div className={styles.btnContainer}>
            <div className={styles.cancelText} onClick={() => setShowApplyTextureModal(false)}>
              Cancel
            </div>
            <ButtonV2
              onClick={proceedAfterModelSelect}
              className={`${styles.continueBtn} ${checkForDisable() && styles.disabled}`}
              color="primary"
              loading={nextBtnLoader}>
              Next
            </ButtonV2>
          </div>
        </div>
      </div>
    </div>
  );
};

const CardData = (props) => {
  const { data, index, setTextureModels, setTextureModelsCopy, textureModelsCopy } = props;

  const toggleSelection = (e, index) => {
    e?.stopPropagation();
    // e?.preventDefault();
    const copyData = JSON.parse(JSON.stringify(textureModelsCopy));
    for (let i = 0; i < copyData?.length; i++) {
      copyData[i].selected = i === index;
    }
    setTextureModels([...copyData]);
    setTextureModelsCopy([...copyData]);
  };
  return (
    <div className={styles.cardParent} key={index}>
      <div
        className={`${styles.imageContainer} ${data.selected ? styles.selected : ''}`}
        onClick={(e) => toggleSelection(e, index)}>
        <Image src={data.thumbnail} placeholderWhileLoading hideWithNoSrc ratio={1.4} />
        {/* <div className={styles.checkboxContainer}>
          <input
            type="checkbox"
            checked={data.selected}
            onChange={(e) => toggleSelection(e, index)}
          />
        </div> */}
      </div>
    </div>
  );
};

const InitHooks = () => {
  const shortcuts = {};
  const unityLoaded = useSelector(selectUnityLoaded);
  useSetupShortcuts(
    {
      shortcuts: shortcuts,
      shortcutsConfig: curatorShortcutsMap,
      areShortcutsEnabled: () => unityLoaded,
    },
    [unityLoaded]
  );
  return null;
};
